import { AudioPlayerOrder, AudioPlayerRepeat, IAudioPlayerConfig } from './AudioPlayer.types';

export const defaultAudioPlayerConfig: IAudioPlayerConfig = {
  speed: 1,
  order: AudioPlayerOrder.Direct,
  repeat: AudioPlayerRepeat.None,
};
